/** Shared classes for dashboard / editor form controls */
export const editorInputClassName =
	"w-full rounded-[12px] border border-darkBlue/15 bg-white px-4 py-3 font-Vazir-400 text-[14px] text-darkBlue outline-none transition placeholder:text-darkBlue/40 focus:border-darkBlue/35 focus:ring-2 focus:ring-cta/15";

export const editorLabelClassName =
	"mb-1.5 block font-Vazir-600 text-[13px] text-darkBlue/80";

export const editorFileLabelClassName =
	"flex w-full flex-col gap-2 rounded-[12px] border border-dashed border-darkBlue/20 bg-lightCta/40 px-4 py-3 font-Vazir-400 text-[13px] text-darkBlue/70";
